import React from "react";
const BuyCoverTable = ({ testData, sortData, refresh, signal }) => {
  const displayBar = (signalRow) => {
    let signalStrength = 0;
    if (signalRow) {
      signalStrength = Math.round(signalRow * 10);
    }
    if (signalStrength > 10) {
      signalStrength = 10;
    }

    const signalColor = (index) => {
      const primaryColor = "#75CE41";
      const halfColor = "linear-gradient(#3E3E3E 50%, #75CE41 50%)";
      const neutralColor = "#3E3E3E";

      const style = [
        [neutralColor, neutralColor, neutralColor, neutralColor, neutralColor],
        [halfColor, neutralColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, neutralColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, halfColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, halfColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, halfColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, primaryColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, primaryColor, halfColor],
        [primaryColor, primaryColor, primaryColor, primaryColor, primaryColor],
      ][signalStrength];
      return style[index];
    };
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          justifyContent: "space-around",
          width: 40,
        }}
      >
        <div
          style={{
            height: 10,
            width: 5,
            backgroundImage: signalColor(0).startsWith("l")
              ? signalColor(0)
              : "unset",
            backgroundColor: signalColor(0),
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 15,
            width: 5,
            backgroundImage: signalColor(1).startsWith("l")
              ? signalColor(1)
              : "unset",
            backgroundColor: signalColor(1),
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 20,
            width: 5,
            backgroundImage: signalColor(2).startsWith("l")
              ? signalColor(2)
              : "unset",
            backgroundColor: signalColor(2),
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 25,
            width: 5,
            backgroundImage: signalColor(3).startsWith("l")
              ? signalColor(3)
              : "unset",
            backgroundColor: signalColor(3),
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 30,
            width: 5,
            backgroundImage: signalColor(4).startsWith("l")
              ? signalColor(4)
              : "unset",
            backgroundColor: signalColor(4),
            borderRadius: 20,
          }}
        ></div>
      </div>
    );
  };
  //Return first 25 results
  return testData.slice(0, 25).map((row, i) => {
    return (
      <div className="asset-info-row" key={i}>
        <div
          className="cell-first buy"
          style={{
            paddingLeft: window.matchMedia("(max-width: 480px)").matches
              ? 0
              : 20,
          }}
        >
          {i + 1}
        </div>
        <div
          className={`cell-first`}
          style={{
            display: "block",
            textAlign: "left",
            margin: "auto",
            marginLeft: 30,
          }}
        >
          {row.name}
        </div>
        <div
          className={`cell-first`}
          style={{ display: "block", textAlign: "center", margin: "auto" }}
        >
          {row.ticker}
        </div>
        <div
          className={
            row.algo_daily_CurrImpVolDiscPrem ? `cell-first buy` : `cell-first`
          }
          style={{
            textAlign: "center",
            margin: "auto",
            display: ["LONGBOW_SIGNAL_STRENGTH", "TRADE_RANGE_ODDS"].includes(
              signal,
            )
              ? "none"
              : "block",
          }}
        >
          {row.algo_daily_CurrImpVolDiscPrem
            ? (row.algo_daily_CurrImpVolDiscPrem * 100).toLocaleString(
                "en-US",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                },
              ) + "%"
            : "- - -"}
        </div>
        <div
          style={{
            position: "relative",
            left: "18%",
            display: ["CURR_IMP_VOL_DISC_PREM", "TRADE_RANGE_ODDS"].includes(
              signal,
            )
              ? "none"
              : "block",
          }}
          className="cell-first buy"
        >
          {displayBar(row.algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH)}
        </div>
        <div
          className={`cell-first`}
          style={{
            textAlign: "center",
            margin: "auto",
            display: [
              "LONGBOW_SIGNAL_STRENGTH",
              "CURR_IMP_VOL_DISC_PREM",
            ].includes(signal)
              ? "none"
              : "block",
          }}
        >
          {row.algo_eod_CALC_TRADE_RANGE_ODDS > 1 ? (
            <div className="buy">
              {row.algo_eod_CALC_TRADE_RANGE_ODDS
                ? row.algo_eod_CALC_TRADE_RANGE_ODDS.toFixed(1)
                : null}
            </div>
          ) : (
            <div className="sell">
              {row.algo_eod_CALC_TRADE_RANGE_ODDS
                ? row.algo_eod_CALC_TRADE_RANGE_ODDS.toFixed(1)
                : null}
            </div>
          )}
        </div>
        <div
          style={{
            color:
              row.red_px_last === null || row.algo_eod_PX_LAST < 1
                ? "white"
                : row.red_px_last
                ? "rgb(211, 53, 65)"
                : "rgb(117, 206, 65)",
          }}
          className="cell-first"
        >
          {row.algo_eod_PX_LAST && row.algo_eod_PX_LAST > 0
            ? "$" +
              row.algo_eod_PX_LAST.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "- - -"}
        </div>

        <div
          className={
            row.algo_eod_CALC_TRADE_RANGE_LOW &&
            row.algo_eod_CALC_TRADE_RANGE_LOW > 0
              ? `cell-first buy`
              : `cell-first`
          }
          style={{ display: "block", textAlign: "center", margin: "auto" }}
        >
          {row.algo_eod_CALC_TRADE_RANGE_LOW &&
          row.algo_eod_CALC_TRADE_RANGE_LOW > 0
            ? "$" +
              row.algo_eod_CALC_TRADE_RANGE_LOW.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "- - -"}
        </div>

        <div
          className={
            row.algo_eod_CALC_TRADE_RANGE_HIGH &&
            row.algo_eod_CALC_TRADE_RANGE_HIGH > 0
              ? `cell-first sell`
              : `cell-first`
          }
        >
          {row.algo_eod_CALC_TRADE_RANGE_HIGH &&
          row.algo_eod_CALC_TRADE_RANGE_HIGH > 0
            ? "$" +
              row.algo_eod_CALC_TRADE_RANGE_HIGH.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "- - -"}
        </div>
      </div>
    );
  });
};

export default React.memo(BuyCoverTable);
